import { useAppTemplateContext } from '@components/v2/layout/AppTemplate/contexts/AppTemplate.context';
import { Box } from '@mui/material';
import useProductDetailsStore from '../../../../../stores/ProductDetails/productDetails.store';
import { selectIsProductDetailsOpen } from '../../../../../stores/ProductDetails/productDetails.store.selectors';
import { ActiveOrderTestIds } from '../../../../../utils/testIds/ActiveOrder.testIds';
import { UsedInOfflineMode } from '../../../../offline/types/UsedInOfflineMode';
import { useRachelPresentation } from '../../../../rachel/hooks/useRachelPresentation';
import { useRachelStore } from '../../../../rachel/store/rachel.store';
import { selectIsRachelOpen } from '../../../../rachel/store/rachel.store.selectors';
import ProductDetailsContent from '../ProductDetailsContent/ProductDetailsContent';
import { useProductDetailsPanelStyles } from './productDetailsPanel.styles';

const ProductDetailsPanel = ({ isOfflineMode = false }: UsedInOfflineMode) => {
  const isOpen = useProductDetailsStore(selectIsProductDetailsOpen);
  const isRachelOpen = useRachelStore(selectIsRachelOpen);
  const rachelPresentation = useRachelPresentation();
  const { sidebarState } = useAppTemplateContext();
  const { classes } = useProductDetailsPanelStyles({
    sidebarState,
    isRachelDocked: isRachelOpen && rachelPresentation.mode === 'docked',
  });

  if (!isOpen) {
    return null;
  }

  return (
    <Box className={classes.panel} test-id={ActiveOrderTestIds.PRODUCT_DETAILS_MODAL}>
      <ProductDetailsContent isOfflineMode={isOfflineMode} />
    </Box>
  );
};

export default ProductDetailsPanel;
